import tippy from 'tippy.js';

tippy('[data-tippy-content]', {
	maxWidth: 298,
	placement: 'auto',
	theme: 'light',
});
